import React from 'react';
import T from 'prop-types';
import { Modal } from 'antd';

const DeleteAccountConfirmModal = ({ deleteAccount, loading, isVisible, setVisibility }) => {
  return (
    <Modal
      bordered={false}
      maskClosable
      okButtonProps={{ loading, type: 'danger' }}
      okText="Delete My Account"
      onCancel={() => setVisibility(false)}
      onOk={deleteAccount}
      title="Delete Account"
      visible={isVisible}
    >
      Deleting your Studio account will disable any API keys you have generated and remove you from our system.
    </Modal>
  );
};

DeleteAccountConfirmModal.propTypes = {
  deleteAccount: T.func.isRequired,
  setVisibility: T.func.isRequired,

  loading: T.bool.isRequired,
  isVisible: T.bool.isRequired,
};

export default DeleteAccountConfirmModal;
